export enum MessageThreadType {
  Case,
  Task,
}
